export const getDataRoomItemsByType = (source, type) => {
  let filteredArray = [];
  if (Array.isArray(source)) {
    source.map(element => element.type === type && (filteredArray.push(element)));
  }
  return filteredArray;
};